import { GraduationCap } from "lucide-react";
import { useState } from "react";

// liste des pays par regions
const countries = [
  { name: "Maroc", region: "Nord", flag: "https://flagcdn.com/w320/ma.png", linkUrl:"/mksp/guide/premium-rg-nord" },
  { name: "Egypte", region: "Nord", flag: "https://flagcdn.com/w320/eg.png", linkUrl:"/mksp/guide/premium-rg-nord" },
  { name: "Algérie", region: "Nord", flag: "https://flagcdn.com/w320/dz.png", linkUrl:"/mksp/guide/premium-rg-nord" },
  { name: "Tunisie", region: "Nord", flag: "https://flagcdn.com/w320/tn.png", linkUrl:"/mksp/guide/premium-rg-nord" },
  { name: "Libye", region: "Nord", flag: "https://flagcdn.com/w320/ly.png", linkUrl:"/mksp/guide/premium-rg-nord" },
  { name: "Soudan", region: "Nord", flag: "https://flagcdn.com/w320/sd.png", linkUrl:"/mksp/guide/premium-rg-nord" },


  { name: "Afrique du Sud", region: "Sud", flag: "https://flagcdn.com/w320/za.png", linkUrl:"/mksp/guide/premium-rg-sud" },
  { name: "Botswana", region: "Sud", flag: "https://flagcdn.com/w320/bw.png", linkUrl:"/mksp/guide/premium-rg-sud" },
  { name: "Namibie", region: "Sud", flag: "https://flagcdn.com/w320/na.png", linkUrl:"/mksp/guide/premium-rg-sud" },
  { name: "Zambie", region: "Sud", flag: "https://flagcdn.com/w320/zm.png", linkUrl:"/mksp/guide/premium-rg-sud" },
  { name: "Zimbabwe", region: "Sud", flag: "https://flagcdn.com/w320/zw.png", linkUrl:"/mksp/guide/premium-rg-sud" },
  { name: "Mozambique", region: "Sud", flag: "https://flagcdn.com/w320/mz.png", linkUrl:"/mksp/guide/premium-rg-sud" },
  { name: "Malawi", region: "Sud", flag: "https://flagcdn.com/w320/mw.png", linkUrl:"/mksp/guide/premium-rg-sud" },
  { name: "Madagascar", region: "Sud", flag: "https://flagcdn.com/w320/mg.png", linkUrl:"/mksp/guide/premium-rg-sud" },
  { name: "Angola", region: "Sud", flag: "https://flagcdn.com/w320/ao.png", linkUrl:"/mksp/guide/premium-rg-sud" },
  { name: "Lesotho", region: "Sud", flag: "https://flagcdn.com/w320/ls.png", linkUrl:"/mksp/guide/premium-rg-sud" },

  { name: "Kenya", region: "Est", flag: "https://flagcdn.com/w320/ke.png", linkUrl:"/mksp/guide/premium-rg-est" },
  { name: "Tanzanie", region: "Est", flag: "https://flagcdn.com/w320/tz.png", linkUrl:"/mksp/guide/premium-rg-est" },
  { name: "Somalie", region: "Est", flag: "https://flagcdn.com/w320/so.png", linkUrl:"/mksp/guide/premium-rg-est" },
  { name: "Ethiopie", region: "Est", flag: "https://flagcdn.com/w320/et.png", linkUrl:"/mksp/guide/premium-rg-est" },
  { name: "Ouganda", region: "Est", flag: "https://flagcdn.com/w320/ug.png", linkUrl:"/mksp/guide/premium-rg-est" },
  { name: "Burundi", region: "Est", flag: "https://flagcdn.com/w320/bi.png", linkUrl:"/mksp/guide/premium-rg-est" },
  { name: "Djibouti", region: "Est", flag: "https://flagcdn.com/w320/dj.png", linkUrl:"/mksp/guide/premium-rg-est" },
  { name: "Érythrée", region: "Est", flag: "https://flagcdn.com/w320/er.png", linkUrl:"/mksp/guide/premium-rg-est" },
  { name: "Rwanda", region: "Est", flag: "https://flagcdn.com/w320/rw.png", linkUrl:"/mksp/guide/premium-rg-est" },


{ name: "Burkina Faso", region: "Ouest", flag: "https://flagcdn.com/w320/bf.png", linkUrl:"/mksp/guide/premium-rg-ouest" },
{ name: "Nigeria", region: "Ouest", flag: "https://flagcdn.com/w320/ng.png", linkUrl:"/mksp/guide/premium-rg-ouest" },
{ name: "Niger", region: "Ouest", flag: "https://flagcdn.com/w320/ne.png", linkUrl:"/mksp/guide/premium-rg-ouest" },
{ name: "Sénégal", region: "Ouest", flag: "https://flagcdn.com/w320/sn.png", linkUrl:"/mksp/guide/premium-rg-ouest" },
{ name: "Côte d'Ivoire", region: "Ouest", flag: "https://flagcdn.com/w320/ci.png", linkUrl:"/mksp/guide/premium-rg-ouest" },
{ name: "Bénin", region: "Ouest", flag: "https://flagcdn.com/w320/bj.png", linkUrl:"/mksp/guide/premium-rg-ouest" },
{ name: "Ghana", region: "Ouest", flag: "https://flagcdn.com/w320/gh.png", linkUrl:"/mksp/guide/premium-rg-ouest" },
{ name: "Togo", region: "Ouest", flag: "https://flagcdn.com/w320/tg.png", linkUrl:"/mksp/guide/premium-rg-ouest" },
{ name: "Liberia", region: "Ouest", flag: "https://flagcdn.com/w320/lr.png", linkUrl:"/mksp/guide/premium-rg-ouest" },
{ name: "Mali", region: "Ouest", flag: "https://flagcdn.com/w320/ml.png", linkUrl:"/mksp/guide/premium-rg-ouest" },
{ name: "Sierra Leone", region: "Ouest", flag: "https://flagcdn.com/w320/sl.png", linkUrl:"/mksp/guide/premium-rg-ouest" },


{ name: "RDC", region: "Centre", flag: "https://flagcdn.com/w320/cd.png", linkUrl:"/mksp/guide/premium-rg-center" },
{ name: "Congo Brazzaville", region: "Centre", flag: "https://flagcdn.com/w320/cg.png", linkUrl:"/mksp/guide/premium-rg-center" },
{ name: "RCA", region: "Centre", flag: "https://flagcdn.com/w320/cf.png", linkUrl:"/mksp/guide/premium-rg-center" },
{ name: "Gabon", region: "Centre", flag: "https://flagcdn.com/w320/ga.png", linkUrl:"/mksp/guide/premium-rg-center" },
{ name: "Tchad", region: "Centre", flag: "https://flagcdn.com/w320/td.png", linkUrl:"/mksp/guide/premium-rg-center" },
{ name: "Cameroun", region: "Centre", flag: "https://flagcdn.com/w320/cm.png", linkUrl:"/mksp/guide/premium-rg-center" },
{ name: "Angola", region: "Centre", flag: "https://flagcdn.com/w320/ao.png", linkUrl:"/mksp/guide/premium-rg-center" },
{ name: "Sao Tomé-et-Principe", region: "Centre", flag: "https://flagcdn.com/w320/st.png", linkUrl:"/mksp/guide/premium-rg-center" },

];

export default function ChoiceCountry() {
  const [search, setSearch] = useState("");
  const [region, setRegion] = useState("Tous");

  const filteredCountries = countries.filter(
    (c) =>
      c.name.toLowerCase().includes(search.toLowerCase()) &&
      (region === "Tous" || c.region === region)
  );

  return (
    <div className="max-w-6xl  mx-auto p-3">
     <section className="dark:bg-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="grid p-6 grid-cols-1 border border-gray-300 dark:border-gray-700 rounded-lg dark:bg-gray-800 gap-6">
            <div className="text-center">
              <div className="bg-blue-100 rounded-full w-12 h-12 flex items-center justify-center mx-auto mb-2">
                <span className="text-3xl text-blue-600 font-bold">
                  {countries.length}
                </span>
              </div>
              <h1 className="dark:text-gray-400 text-gray-600 text-1xl">
                Sélectionnez votre pays d’origine
              </h1>
            </div>
          </div>
        </div>
      </section>

      {/* Barre de recherche et filtre */}
      <div className="flex flex-col sm:flex-row gap-4 mb-6">
        <input
          type="text"
          placeholder="Rechercher un pays..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="flex-1 border dark:bg-gray-800 dark:border-gray-700 rounded-xl px-4 py-2  dark:text-gray-200 shadow-sm focus:ring focus:ring-blue-300"
        />

       <div className="relative ">
  <select
    value={region}
    onChange={(e) => setRegion(e.target.value)}
    className="w-full appearance-none rounded-lg border dark:text-gray-400 dark:border-gray-700 bg-white dark:bg-gray-800 px-4 py-2 pr-8 text-gray-700 shadow-sm  focus:ring-2 focus:ring-green-800 focus:outline-none transition duration-200"
  >
    <option value="Tous" className="font-bold text-gray-500">
     Tous
    </option>
    <option className=" font-bold" value="Nord"> Pays du Nord</option>
    <option className=" font-bold" value="Sud"> Pays du Sud</option>
    <option className=" font-bold" value="Est"> Pays de l'Est</option>
    <option className=" font-bold" value="Ouest"> Pays de l'Ouest</option>
    <option className=" font-bold" value="Centre"> Pays du Centre</option>
  </select>

  {/* Flèche du tab*/}
  <div className="pointer-events-none absolute inset-y-0 right-3 flex items-center text-gray-400">
    <svg
      className="h-4 w-4"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      viewBox="0 0 24 24"
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
    </svg>
  </div>
</div>

      </div>

      {/* Liste des pays */}
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
        {filteredCountries.map((c) => (
          <div
            key={c.name}
            className="group rounded-md border border-gray-200 dark:border-gray-700 
        overflow-hidden shadow-sm hover:shadow-md 
        transition-all duration-300 bg-white dark:bg-gray-800"
          >
            <a href={c.linkUrl} className="block h-full">
              <div className="relative h-24 w-full  overflow-hidden">
                <img
                  src={c.flag || "/placeholder.svg"}
                  alt={`Campus de ${c.name}`}
                  className=" w-full object-cover transition-transform duration-500 group-hover:scale-110"
                  onError={(e) => {
                    e.target.src =
                      "https://images.unsplash.com/photo-1562774053-701939374585?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80"
                  }}
                />
              </div>
              <div className="p-1">
                <h1 className=" text-center font-bold text-gray-900 dark:text-gray-100">
                  {c.name}
                </h1>
              </div>
            </a>
          </div>
        ))}
        
      </div>
      { filteredCountries.length === 0 && (
          <div className="text-center py-12">
            <GraduationCap className="h-12 w-12 text-gray-400 mx-auto mb-4" />
            <h3 className="text-lg font-medium dark:text-gray-200 text-gray-900 mb-2">Non répertorié sur Mksp</h3>
            <p className="text-gray-600">Aucun pays</p>
          </div>
        )}
    </div>
  );
}
